const PORTAL_PATH = /^\/p\/([^/]+)\/([^/]+)\/?$/;

const decodeSegment = (value) => {
  try {
    return decodeURIComponent(String(value || ''));
  } catch (e) {
    return String(value || '');
  }
};

/**
 * Company and portal shortCodes are free text. Some tenants store a blank
 * (`"seguros bolivar"`, leading/trailing space, NBSP). That must not break
 * `/p/:company/:portal` or `/auth/portal` Basic auth.
 */
export const normalizePortalSlug = (value) =>
  decodeSegment(value)
    .replace(/[\u00a0\u1680\u2000-\u200b\u202f\u205f\u3000\t\n\r\f\v]+/g, ' ')
    .replace(/ {2,}/g, ' ')
    .trim();

const encodeSegment = (value) => {
  const slug = normalizePortalSlug(value);
  return slug ? encodeURIComponent(slug) : '';
};

export const parsePortalPath = (pathname = '') => {
  const match = String(pathname).match(PORTAL_PATH);
  if (!match) return null;
  const companyCode = normalizePortalSlug(match[1]);
  const portalCode = normalizePortalSlug(match[2]);
  if (!companyCode || !portalCode) return null;
  return { companyCode, portalCode };
};

export const buildPortalPath = (companyCode, portalCode) => {
  const company = encodeSegment(companyCode);
  const portal = encodeSegment(portalCode);
  if (!company || !portal) return null;
  return `/p/${company}/${portal}`;
};

/** Slugs from DVA/stash. `shortCode` is the portal slug when `portalCode` is missing. */
export const pathFromPortalConfig = (config, portalId) => {
  if (!config) return null;
  if (portalId && (!config.id || String(config.id) !== String(portalId))) return null;
  const companyCode = config.companyCode;
  const portalCode = config.portalCode || config.shortCode;
  return buildPortalPath(companyCode, portalCode);
};

/**
 * Lookups try the stored slug (spaces included) and the hyphenated form.
 * `/auth/portal` is exact-match on the slug the portal was created with.
 */
export const portalSlugVariants = (value) => {
  const raw = normalizePortalSlug(value);
  if (!raw) return [];
  return [...new Set([raw, raw.replace(/[\s_]+/g, '-'), raw.replace(/[-_]+/g, ' ')])];
};
